import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../styles/HomePageStyles/footer.css";

import logo from "../assets/logo6.png";
import insta from "../assets/Footer/instaIng.webp";
import fbImg from "../assets/Footer/fbImg.png";
import tiktokImg from "../assets/Footer/tiktokImg.png";
import ytImg from "../assets/Footer/ytImg.png";

import roll1 from "../assets/Footer/header1.png";
import roll2 from "../assets/Footer/header2.png";
import roll5 from "../assets/Footer/footer.png";
import { Link, useLocation } from "react-router-dom";
import config from "../config";
import OrderBtn from "../utils/OrderBtn";
import axios from "axios";
import swal from "sweetalert";

const Footer = ({
  color,
  footer_title,
  footer_description,
  footer_left_image,
  footer_right_image,
  intsLink,
  fbLink,
  tiktokLink,
  ytLink,
}) => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  const [clEmail, setClEmail] = useState("");
  const [error, setError] = useState("");

  const [COLOR, setColor] = useState();

  const location = useLocation();

  useEffect(() => {

    if (location.pathname === `${config.appUrl}/our-story`) {
      setColor("#fff");
    } else if (location.pathname === `${config.appUrl}/franchise` || location.pathname === `${config.appUrl}/privacy-policy` || location.pathname === `${config.appUrl}/franchise-form`) {
      setColor("#ffdbe2");
    } else if (location.pathname === `${config.appUrl}`) {
      setColor("#ffecf0");
    }
    else setColor("#ffecf0");

  }, [location.pathname]);

  const validateEmail = () => {
    let newError = "";

    if (clEmail === "") {
      newError = "Email is Required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(clEmail)
    ) {
      newError = "Please enter a valid email address";
    }

    // Set the error state if there's an error
    setError(newError);
    return newError;
  };

  const sendEmail = async () => {
    const validationError = validateEmail();
    if (validationError) {
      return swal({
        icon: "warning",
        text: "Please Enter Valid Email Id",
      });
    }

    const formData = new FormData();
    formData.append("email", clEmail);
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/store-email-leads`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setClEmail("");
        swal({
          icon: "success",
          text: "Message sent successfully !",
        });
      });
    } catch (error) {
      swal({
        icon: "error",
        text: "Something went wrong",
      });
    }
  };

  return (
    <div className="footer_container_wrapper">
      <div className="foot_bg1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          // fill="var(--heading-color)"
          style={{ fill: COLOR }}
        >
          <path d="M0 0v60c9 0 18-3 25-10 13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s36 14 50 0c13-14 36-14 50 0s37 13 50 0c14-14 37-14 50 0 7 7 16 10 25 10V0H0Z"></path>
        </svg>
      </div>

      <div className="contianer_wrapper footer_container">
        <div className="footer_wrapper">
          <div className="footer_img1 footer_imgs">
            <div className="footer_img1_container">
              <img
                src={
                  footer_left_image && footer_left_image !== "-"
                    ? footer_left_image
                    : roll1
                }
                alt=""
                className="img-fluid"
              />
            </div>
          </div>

          <div className="footer_heading" data-aos="zoom-out">
            {/* {footer_title && footer_title !== "-" ? (
              <h2>{footer_title}</h2>
            ) : (
              <h2>Have questions or need more info?</h2>
            )} */}
            <h2>{footer_title}</h2>
            <p>{footer_description}</p>

            {/* {footer_description && footer_description !== "-" ? (
              <p>{footer_description}</p>
            ) : (
              <p>
                Email us today for any inquiries about our delicious rolled ice
                cream – we're here to help!
              </p>
            )} */}

            <div className="email_action">
              <input
                type="email"
                placeholder="Enter Email Address"
                className="form-control mb-1"
                value={clEmail}
                onChange={(e) => setClEmail(e.target.value)}
                required
              />
              <div className="order-online">
                <button
                  className="blue-btn hero-anchor"
                  onClick={() => sendEmail()}
                >
                  <div className="order-online-trans-1"></div>
                  <div className="order-online-trans-2"></div>
                  Email Us
                </button>
              </div>
            </div>
          </div>

          <div className="footer_img2 footer_imgs">
            <div className="footer_img2_container">
              <img
                src={
                  footer_right_image && footer_right_image !== "-"
                    ? footer_right_image
                    : roll2
                }
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="d-lg-flex d-md-none d-none d-sm-none footer_links">
        <div className="links_img">
          <img src={roll5} alt="" className="img-fluid" />
        </div>

        {/* <div className="footer_Services">
          <h5>Services</h5>

          <p>
            <Link to={`${config.appUrl}/privacy-policy`}>Privacy Policy</Link>
          </p>

          <p>
            <Link to={`${config.appUrl}/blog`}>Blogs</Link>
          </p>
        </div> */}

        <div className="footer_useful_links">
          <h5>Useful Links</h5>

          <p>
            <Link to={`${config.appUrl}/menu`}>Menu</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}`}>Locations</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/franchise`}>Franchise</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/our-story`}>Our Story</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/contact-us`}>Contact Us</Link>
          </p>

          <p>
            <Link to={`${config.appUrl}/blog`}>Blogs</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/privacy-policy`}>Privacy Policy</Link>
          </p>
        </div>

        <div className="footer_contact_us">
          <h5>Get In Touch</h5>

          <p className="d-flex">
            <span className="location_icon">
              <i className="bi bi-telephone-fill"></i>
            </span>
            <span className="location_detaiils ms-2">
              <a
                href={"tel: 416-293-2223"}
                className="d-flex align-items-center"
              >
                416-293-2223
              </a>
            </span>
          </p>
          <p>
            <span className="location_icon">
              <i className="bi bi-envelope-at-fill"></i>
            </span>
            <span className="location_detaiils ms-2">
              <a href="mailto:info@rollzicecream.ca" className="">
                info@rollzicecream.ca
              </a>
            </span>
          </p>
          {/* <p>
            <span className="location_icon">
              <i className="bi bi-cart4"></i>
            </span>
            <span className="location_detaiils ms-2">
              <a href="https://order.tikme.co/" target="_blank">
                Order Now
              </a>
            </span>
          </p> */}
        </div>

        <div className="footer_logo_cont">
          <div className="footer_logo">
            <img src={logo} alt="" className="img-fluid" />
          </div>
          <h4>Head Office</h4>
          <p>5746 Finch Ave E, Unit 3, Scarborough, ON M1B 5J9, Canada</p>
        </div>
      </div>

      {/* For Responsive device  */}
      <div className="col-12 d-flex d-lg-none d-md-flex d-sm-flex footer_links">
        <div className="col-sm-3 footer_logo_cont">
          <div className="footer_logo">
            <img src={logo} alt="" className="img-fluid" />
          </div>
          <h4>Head Office</h4>
          <p>5746 Finch Ave E, Unit 3, Scarborough, ON M1B 5J9, Canada</p>
        </div>

        {/* <div className="col-sm-3 footer_Services">
          <h5>Services</h5>
         
          <p>
            <Link to={`${config.appUrl}/privacy-policy`}>Privacy Policy</Link>
          </p>

          <p>
            <Link to={`${config.appUrl}/blog`}>Blogs</Link>
          </p>
        </div> */}

        <div className="col-sm-3 footer_useful_links">
          <h5>Useful Links</h5>
          <p>
            <Link to={`${config.appUrl}/menu`}>Menu</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}`}>Locations</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/franchise`}>Franchise</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/our-story`}>Our Story</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/contact-us`}>Contact Us</Link>
          </p>

          <p>
            <Link to={`${config.appUrl}/blog`}>Blogs</Link>
          </p>
          <p>
            <Link to={`${config.appUrl}/privacy-policy`}>Privacy Policy</Link>
          </p>
        </div>

        <div className="col-sm-3 footer_contact_us">
          <h5>Get In Touch</h5>

          <p className="d-flex">
            <span className="location_icon">
              <i className="bi bi-telephone-fill"></i>
            </span>
            <span className="location_detaiils ms-2">
              <a
                href={"tel: 416-293-2223"}
                className="d-flex align-items-center"
              >
                416-293-2223
              </a>
            </span>
          </p>
          <p>
            <span className="location_icon">
              <i className="bi bi-envelope-at-fill"></i>
            </span>
            <span className="location_detaiils ms-2">
              <a href="mailto:info@rollzicecream.ca" className="">
                info@rollzicecream.ca
              </a>
            </span>
          </p>

        </div>
      </div>

      <div className="copyright  d-flex flex-column flex-md-row">
        <div className="promotion_text">
          <Link to="https://zithas.ca/" target="_blank">
            Design and Managed by Zithas Technologies.
          </Link>
        </div>
        <div className="copyright_icons">
          <a
            href={intsLink || "https://www.instagram.com/rollzicecreams/"}
            target="_blank"
            title="Rollz Ice Creams - Instagram"
          >
            <img src={insta} alt="" className="img-fluid" />
          </a>

          <a
            href={fbLink || "https://www.facebook.com/rollzicecream"}
            target="_blank"
            title="Rollz Ice Creams - Facebook"
          >
            <img src={fbImg} alt="" className="img-fluid" />
          </a>

          <a
            href={tiktokLink || "https://www.tiktok.com/@rollzicecream"}
            target="_blank"
            title="Rollz Ice Creams - TikTok"
          >
            <img src={tiktokImg} alt="" className="img-fluid" />
          </a>
          <a
            href={ytLink || "https://www.youtube.com/@rollzicecream"}
            target="_blank"
            title="Rollz Ice Creams - Youtube"
          >
            <img src={ytImg} alt="" className="img-fluid" />
          </a>
        </div>

        <div className="copyright_line">
          © 2025 Rollz Ice Cream. All Rights Reserved.
        </div>
      </div>

    </div>
  );
};

export default Footer;
